import { render } from "./BuyProduct.vue?vue&type=template&id=b8440b98&scoped=true"
import script from "./BuyProduct.vue?vue&type=script&lang=js"
export * from "./BuyProduct.vue?vue&type=script&lang=js"

import "./BuyProduct.vue?vue&type=style&index=0&id=b8440b98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8440b98"]])

export default __exports__